import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Rx';
import * as globals from '../globals';
import { AuthHttp, AuthConfig } from 'angular2-jwt';

@Injectable()
export class resourceAdminService {

    private quoteUrl = globals.APIURL + '/admin/quote';
    private CategoryUrl = this.quoteUrl + '/category';
    private ResourceUrl = this.quoteUrl + '/resource';
    private LocationUrl = this.quoteUrl + '/location';
    private CostingUrl = this.quoteUrl + '/costing';
    private TimeunitUrl = this.quoteUrl + '/costtypeunit';
    private CosttypeUrl = this.quoteUrl + '/costtype';

    constructor(private http: Http, public authHttp: AuthHttp) {

    }

    /**
     * fetch all Resources in MR2 Database
     * @return JSON response body / Error
     */
    getResources(): Observable<string> {
        let headers = new Headers({ 'Content-Type': 'application/json' });
        let options = new RequestOptions({ body: '', headers: headers });
        return this.authHttp.get(this.ResourceUrl, options)
            .map(this.extractData)
            .catch(this.handleError);
    }


    /**
     * Add new location in MR2 Database
     * @param string location name
     * @return JSON response body / Error
     */
    addNewLocation(location: any): Observable<string> {
        console.log('get users service called');

        let headers = new Headers({
            'Content-Type': 'application/json'
        });

        let body = JSON.stringify({
            name: location
        });

        let options = new RequestOptions({ headers: headers });

        console.log('Projects: OPTIONS =>', options);
        console.log('URL:', this.LocationUrl);

        return this.authHttp.post(this.LocationUrl, body, options)
            .map(this.extractData)
            .catch(this.handleError);
    }

    /**
    * Add new resource in MR2 Database
    * @param string resource name
    * @return JSON response body / Error
    */
    addNewResource(resource: any, costing: any): Observable<string> {
        console.log('get users service called');

        let headers = new Headers({
            'Content-Type': 'application/json'
        });

        let body = JSON.stringify({
            resource: { name: resource.name, category_id: resource.category_id, description: resource.description, location_id: resource.location_id }, costings: costing
        });

        let options = new RequestOptions({ headers: headers });

        console.log('Projects: OPTIONS =>', options);
        console.log('URL:', this.ResourceUrl);

        return this.authHttp.post(this.ResourceUrl, body, options)
            .map(this.extractData)
            .catch(this.handleError);
    }

    /**
    * Add new resource in MR2 Database
    * @param string resource name
    * @return JSON response body / Error
    */
    updateResource(resource: any): Observable<string> {
        console.log('get users service called');

        let headers = new Headers({
            'Content-Type': 'application/json'
        });

        let body = JSON.stringify({
            resource: { id: resource.id, name: resource.name, category_id: resource.category_id, description: resource.description, location_id: resource.location_id }
        });

        let options = new RequestOptions({ headers: headers });

        console.log('Projects: OPTIONS =>', options);
        console.log('URL:', this.ResourceUrl);

        return this.authHttp.put(this.ResourceUrl + '/' + resource.id, body, options)
            .map(this.extractData)
            .catch(this.handleError);
    }

    /**
      * Add new Category in MR2 Database
      * @param string category name
      * @return JSON response body / Error
      */
    addNewCategory(category_name: any): Observable<string> {
        console.log('get users service called');

        let headers = new Headers({
            'Content-Type': 'application/json'
        });

        let body = JSON.stringify({
            name: category_name
        });

        let options = new RequestOptions({ headers: headers });

        console.log('Projects: OPTIONS =>', options);
        console.log('URL:', this.CategoryUrl);

        return this.authHttp.post(this.CategoryUrl, body, options)
            .map(this.extractData)
            .catch(this.handleError);
    }

    /**
      * edit Category in MR2 Database
      * @param string category name
      * @return JSON response body / Error
      */
    editCategory(category: any, updatedName: string): Observable<string> {
        console.log('get users service called');

        let headers = new Headers({
            'Content-Type': 'application/json'
        });

        let body = JSON.stringify({
            id: category.id, name: updatedName,
        });

        let options = new RequestOptions({ headers: headers });
        console.log('Projects: OPTIONS =>', options);
        console.log('URL:', this.CategoryUrl + '/' + category.id);

        return this.authHttp.put(this.CategoryUrl + '/' + category.id, body, options)
            .map(this.extractData)
            .catch(this.handleError);
    }

    /**
      * remove Category in MR2 Database
      * @param string category name
      * @return JSON response body / Error
      */
    removeCategory(category: any): Observable<string> {
        console.log('get users service called');

        let headers = new Headers({
            'Content-Type': 'application/json'
        });

        let body = JSON.stringify({
            name: category.name
        });

        let options = new RequestOptions({ headers: headers });
        console.log('Projects: OPTIONS =>', options);
        console.log('URL:', this.CategoryUrl + '/' + category.id);

        return this.authHttp.delete(this.CategoryUrl + '/' + category.id, options)
            .map(this.extractData)
            .catch(this.handleError);
    }

    /**
  * remove Resource in MR2 Database
  * @param string Resource name
  * @return JSON response body / Error
  */
    removeResource(resource: any): Observable<string> {
        console.log('get users service called');

        let headers = new Headers({
            'Content-Type': 'application/json'
        });

        let options = new RequestOptions({ headers: headers });
        console.log('Projects: OPTIONS =>', options);
        console.log('URL:', this.ResourceUrl + '/' + resource.id);

        return this.authHttp.delete(this.ResourceUrl + '/' + resource.id, options)
            .map(this.extractData)
            .catch(this.handleError);
    }


    updateResourcescategories(oldResourceID: any, newResourceID: any): Observable<string> {

        let headers = new Headers({
            'Content-Type': 'application/json'
        });

        let body = JSON.stringify({
            category:
            {
                old: oldResourceID,
                new: newResourceID
            }
        });

        let options = new RequestOptions({ headers: headers });
        // console.log('Projects: OPTIONS =>', options);
        console.log('URL:', this.ResourceUrl);

        return this.authHttp.put(this.ResourceUrl, body, options)
            .map(this.extractData)
            .catch(this.handleError);
    }

    /**
    * Add new resource in MR2 Database
    * @param string resource name
    * @return JSON response body / Error
    */
    addCosting(costing: any): Observable<string> {
        console.log('Add costing service called');

        let headers = new Headers({
            'Content-Type': 'application/json'
        });

        let body = JSON.stringify({
            costtype_id: costing.costtype_id, resource_id: costing.resource_id, description: costing.description, costtypeunit_id: costing.costtypeunit_id, cost: costing.cost, burden: costing.burden
        });

        let options = new RequestOptions({ headers: headers });

        console.log('Costing: OPTIONS =>', options);
        console.log('Costing URL:', this.CostingUrl);

        return this.authHttp.post(this.CostingUrl, body, options)
            .map(this.extractData)
            .catch(this.handleError);
    }

    /**
    * Add new resource in MR2 Database
    * @param string resource name
    * @return JSON response body / Error
    */
    updateCosting(costing: any): Observable<string> {
        console.log('get users service called');

        let headers = new Headers({
            'Content-Type': 'application/json'
        });

        let body = JSON.stringify({
            description: costing.description, costtypeunit_id: costing.costtypeunit_id, cost: costing.cost, burden: costing.burden
        });

        let options = new RequestOptions({ headers: headers });

        console.log('Costing: OPTIONS =>', options);
        console.log('Costing URL:', this.CostingUrl);

        return this.authHttp.put(this.CostingUrl + '/' + costing.id, body, options)
            .map(this.extractData)
            .catch(this.handleError);
    }

    removeCosting(costingID) {
        console.log('get users service called');

        let headers = new Headers({
            'Content-Type': 'application/json'
        });

        let body = JSON.stringify({
            enabled: 0
        });

        let options = new RequestOptions({ headers: headers });

        console.log('Costing: OPTIONS =>', options);
        console.log('Costing URL:', this.CostingUrl);

        return this.authHttp.put(this.CostingUrl + '/' + costingID, body, options)
            .map(this.extractData)
            .catch(this.handleError);
    }

    removeCostingFromResource(resource, CostingID) {
        console.log('get users service called');

        let headers = new Headers({
            'Content-Type': 'application/json'
        });
        let updatedCostingIdArray = [];
        for (let i = 0, j = 0; i < resource.costings.length; i++) {
            if (resource.costings[i] !== CostingID) {
                updatedCostingIdArray[j] = resource.costings[i];
                j++;
            }
        }

        let body = JSON.stringify({
            resource: { id: resource.id, name: resource.name, category_id: resource.category_id, description: resource.description, location_id: resource.location_id }, costings: updatedCostingIdArray
        });

        let options = new RequestOptions({ headers: headers });

        // console.log('Projects: OPTIONS =>', options);
        // console.log('URL:', this.ResourceUrl);

        return this.authHttp.put(this.ResourceUrl + '/' + resource.id, body, options)
            .map(this.extractData)
            .catch(this.handleError);
    }

    private extractData(res: Response) {
        let body = res.json();
        console.log('BODY:', body);
        return body || {};
    }

    handleError(error: any) {
        // In a real world app, we might use a remote logging infrastructure
        // We'd also dig deeper into the error to get a better message
        let errMsg = (error.message) ? error.message :
            error.status ? `${error.status} - ${error.statusText}` : 'Server error';
        console.error('CAUGHT AN ERROR:', errMsg); // log to console instead
        return Observable.throw(errMsg);
    }
}



// WEBPACK FOOTER //
// /Users/mark/Documents/Source/MachineResearch/MR2/angular2/src/app/resourceadmin/resourceadmin.service.ts